export default __webpack_public_path__ + "static/media/meditation.8b852e35.jpg";